module.exports = __webpack_public_path__ + "common/tp-featured8-41ab27cddb7076eaef484c6c5a3f0886.svg";